import {createBasicReducer} from '../../utils/redux'
import {basicActions} from './actions'
import {initialState} from './constants'
import {GlobalState} from './types'

export const reducer = createBasicReducer<GlobalState>(initialState, basicActions)
